import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51M96.257 17.002a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M80.987 5.295a1.5 1.5 0 0 1 0 2.121l-9.993 9.994a1.5 1.5 0 0 1-2.122-2.121l9.993-9.994a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M68.873 5.295a1.5 1.5 0 0 1 2.12 0l9.994 9.994a1.5 1.5 0 1 1-2.122 2.121l-9.993-9.994a1.5 1.5 0 0 1 0-2.121"
      clipRule="evenodd"
    />
    <path
      fill="#0597A3"
      d="M49.44 109.13a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M13.633 65.097a1.5 1.5 0 0 1 1.5 1.5V80.73a1.5 1.5 0 0 1-3 0V66.597a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M5.066 73.664a1.5 1.5 0 0 1 1.5-1.5H20.7a1.5 1.5 0 1 1 0 3H6.566a1.5 1.5 0 0 1-1.5-1.5M24.594 95.32a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#0597A3"
      d="M88.661 54.594a2.633 2.633 0 0 0-2.633-2.633H32.447a2.633 2.633 0 0 0-2.633 2.633v15.51h58.847z"
    />
    <path
      fill="#00D8D8"
      d="M29.814 70.105v15.511a2.633 2.633 0 0 0 2.633 2.633h53.581a2.633 2.633 0 0 0 2.633-2.632V70.104z"
    />
    <path
      fill="#001A43"
      fillRule="evenodd"
      d="M72.835 60.916a4.056 4.056 0 1 1 8.112 0 4.056 4.056 0 0 1-8.112 0"
      clipRule="evenodd"
    />
    <path
      fill="#001A43"
      d="M72.835 79.294a4.056 4.056 0 1 1 8.112 0 4.056 4.056 0 0 1-8.112 0"
    />
    <path
      fill="#00D8D8"
      d="M86.548 26.46H65.122v17.654h21.426a2.113 2.113 0 0 0 2.113-2.113V28.572a2.11 2.11 0 0 0-2.113-2.112"
    />
    <path
      fill="#001A43"
      d="M31.926 26.46a2.113 2.113 0 0 0-2.113 2.113v13.429c0 1.167.946 2.113 2.113 2.113h33.195V26.461z"
    />
    <path
      fill="#001A43"
      fillRule="evenodd"
      d="M71.907 32.118a1.5 1.5 0 0 1 2.122 0l2.862 2.862 2.862-2.862a1.5 1.5 0 1 1 2.122 2.121l-3.923 3.923a1.5 1.5 0 0 1-2.122 0l-3.923-3.923a1.5 1.5 0 0 1 0-2.12"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEnrichedIconChoiceInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconChoiceInverted);
export default Memo;
